module.exports = __webpack_public_path__ + "files/8bbe231965578531d81dad98c011b0ee.png";